/**
 * 超时冲调信息
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { Table, Alert, Tooltip, Select, Input, Form } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import intl from 'react-intl-universal';
import { InfoCircleOutlined } from '@ant-design/icons';
import { parseSeconds2Hour } from '@/utils/date';
import { parseFen2Currency } from '@/utils/number';

import { updateAdjustRecordChange } from '@/redux/actions/bill/settle';
import { AdjustRecordInfo } from '@/redux/reducers/reservation/checkOut';
import { validReverseRemark, ReverseResonCodeQT } from '@/pages/reservation/roomExchange/helper';

import commonStyles from '../../../common.module.scss';
import styles from './index.module.scss';

const Index: React.FC<any> = (props) => {
  const { adjustReasons, orderInfo, callItemChange } = props;
  const { overtimePriceAdjustList } = orderInfo;

  if (!overtimePriceAdjustList || overtimePriceAdjustList.length === 0) return null;

  // 冲调原因
  const handleAdjustReasonChange: (adjustReason: string, record: AdjustRecordInfo) => void = (
    adjustReason,
    record,
  ) => {
    // if (PRICE_REG.test(overtimePrice)) {
    callItemChange(record.indexId, { adjustReason });
    // }
  };

  const renderReasonItem: (value: string, record: AdjustRecordInfo) => React.ReactNode = (
    value,
    record,
  ) => {
    return (
      <Select
        style={{ width: '140px' }}
        placeholder={intl.get('app_search_form_option_label_please')}
        options={adjustReasons}
        value={value}
        onChange={(val) => {
          handleAdjustReasonChange(val, record);
        }}
      />
    );
  };

  // 冲调备注
  const handleAdjustRemarkChange: (adjustRemarks: string, record: AdjustRecordInfo) => void = (
    adjustRemarks,
    record,
  ) => {
    callItemChange(record.indexId, { adjustRemarks });
  };

  const renderRemarksItem: (value: string, record: AdjustRecordInfo) => React.ReactNode = (
    value,
    record,
  ) => {
    const placeholderText =
      record?.adjustReason !== ReverseResonCodeQT
        ? intl.get('bill_credit_account_remark_placeholder')
        : intl.get('bill_cross_refound_remark_label');
    return (
      <Form>
        <Form.Item
          name="adjustRemarks"
          rules={[
            {
              validator: (_, val) => validReverseRemark(_, val, record?.adjustReason),
            },
          ]}
          className={styles.adjustRemarksItem}
        >
          <Input
            style={{ width: '100%' }}
            value={value}
            placeholder={placeholderText}
            maxLength={10000}
            onChange={(e) => handleAdjustRemarkChange(e.target.value, record)}
          />
        </Form.Item>
      </Form>
    );
  };

  const tableColumns: ColumnsType<AdjustRecordInfo> = [
    {
      title: intl.get('app_constants_room_type'),
      dataIndex: 'roomTypeName',
      key: 'roomTypeName',
    },
    { title: intl.get('app_constants_room_no'), dataIndex: 'roomNo', key: 'roomNo' },
    {
      title: intl.get('drawer_checkout_room_column_overtime_value'),
      dataIndex: 'overtime',
      key: 'overtime',
      render: (val) => (val == null ? '00:00:00' : parseSeconds2Hour(val)),
    },
    {
      title: intl.get('drawer_checkout_room_column_overtime_price'),
      dataIndex: 'overtimePriceReceivable',
      key: 'overtimePriceReceivable',
      align: 'right',
      filterDropdown: true,
      filterIcon: (
        <Tooltip
          title={intl.get('drawer_checkout_room_column_overtime_price_tips')}
          placement="top"
        >
          <InfoCircleOutlined />
        </Tooltip>
      ),
      render: (val, record) => parseFen2Currency(record?.overtimePriceReceivable || 0),
    },
    {
      title: intl.get('drawer_checkout_room_column_overtime_price_actual'),
      dataIndex: 'overtimePrice',
      key: 'overtimePrice',
      align: 'right',
      width: 240,
      render: (val) => parseFen2Currency(val || 0),
    },
    {
      title: intl.get('drawer_checkout_reverse_amount'),
      dataIndex: 'adjustPrice',
      key: 'adjustPrice',
      align: 'right',
      render: (val) => {
        return <span className={styles.redColor}>{parseFen2Currency(val || 0)}</span>;
      },
    },
    {
      title: intl.get('drawer_checkout_reverse_reason'),
      dataIndex: 'adjustReason',
      key: 'adjustReason',
      render: renderReasonItem,
    },
    {
      title: intl.get('drawer_checkout_reverse_remarks'),
      dataIndex: 'adjustRemarks',
      key: 'adjustRemarks',
      render: renderRemarksItem,
    },
  ];

  return (
    <dl className={styles['settle-order-block']} style={{ marginTop: 40 }}>
      <dt className={commonStyles['bill-block-title']}>
        {intl.get('drawer_checkout_overtime_room_fee_reverse')}
      </dt>
      <dd>
        <Alert
          message={intl.get('drawer_checkout_overtime_room_fee_reverse_tips')}
          type="info"
          showIcon
          className={styles.alert}
        />
        <Table
          pagination={false}
          className={styles.rentRoomContainer}
          rowKey="indexId"
          columns={tableColumns}
          dataSource={overtimePriceAdjustList}
        />
      </dd>
    </dl>
  );
};

const mapStateToProps = (state) => {
  const { orderInfoLoading, orderInfo } = state.settle;
  const { roomCardEnabled } = state.card;
  return { orderInfoLoading, orderInfo, roomCardEnabled };
};

export default connect(mapStateToProps, { callItemChange: updateAdjustRecordChange })(memo(Index));
